import React, { useEffect, useState } from 'react'
import {
    loadCaptchaEnginge, LoadCanvasTemplate,
    validateCaptcha
} from 'react-simple-captcha';
import Input from '../controls/Input';
import { TbReload } from "react-icons/tb";

function MyCaptcha({ count = 6, setResult }) {
    const [ctext, setCtext] = useState("");

    useEffect(() => {
        loadCaptchaEnginge(count, "lightgray", "green");
    }, [])

    const setText = (e) => {
        setResult(e.target.value)
        setCtext(e.target.value)
    }

    return (
        <>
            <LoadCanvasTemplate reloadText="Reload" reloadColor="#5090C1" />
            <Input placeholder="Capthch Text" type="text" value={ctext} onChange={setText} />
        </>
    )
}
export { MyCaptcha, validateCaptcha }
